import { useTranslation } from 'react-i18next';
import { useAllCampaignCategoryOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const CampaignCategoryField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allCampaignCategoryOptions } = useAllCampaignCategoryOptions();

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="campaignCategoryIds"
      options={allCampaignCategoryOptions}
      title={t("Selector.Account's Interest")}
      multiple
      {...props}
    />
  );
};
